import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, Button, Grid, Slider, TextField, InputAdornment
} from '@mui/material';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import { modernTheme } from '../theme';

const AdvancePaymentDialog = ({
  open, onClose, loading,
  userSummary, advancePercentage, onPercentageChange,
  advanceAmount, onAmountChange, maxAdvanceAmount,
  onSubmit
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
      PaperProps={{ sx: { borderRadius: 3, overflow: 'hidden' } }}
    >
      <DialogTitle sx={{
        background: modernTheme.gradients.primary,
        color: 'white', py: 2.5
      }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Box sx={{
            width: 40, height: 40, borderRadius: 2,
            bgcolor: 'rgba(255,255,255,0.2)',
            display: 'flex', alignItems: 'center', justifyContent: 'center'
          }}>
            <CreditScoreIcon />
          </Box>
          <Box>
            <Typography variant="h6" fontWeight={700}>Yêu cầu ứng tiền</Typography>
            <Typography variant="caption" sx={{ opacity: 0.85 }}>
              Tối đa 50% thu nhập kỳ này
            </Typography>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ pt: 3, pb: 1 }}>
        <Box sx={{ p: 2, bgcolor: modernTheme.colors.gray[50], borderRadius: 2, mb: 3, border: `1px solid ${modernTheme.colors.gray[200]}` }}>
          <Typography variant="body2" color="text.secondary" mb={0.5}>Thu nhập kỳ này</Typography>
          <Typography variant="h5" fontWeight={700} color={modernTheme.colors.primary}>
            {userSummary ? new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(userSummary.currentPeriod.earnings) : '0 ₫'}
          </Typography>
          <Typography variant="caption" color="text.secondary" mt={1} display="block">
            Tối đa có thể ứng: {new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(maxAdvanceAmount)}
          </Typography>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" fontWeight={600} mb={1.5}>Chọn phần trăm ứng tiền</Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs>
              <Slider
                value={advancePercentage}
                onChange={onPercentageChange}
                min={1} max={50}
                marks={[
                  { value: 10, label: '10%' },
                  { value: 20, label: '20%' },
                  { value: 30, label: '30%' },
                  { value: 40, label: '40%' },
                  { value: 50, label: '50%' },
                ]}
                valueLabelDisplay="auto"
                sx={{
                  color: modernTheme.colors.primary,
                  '& .MuiSlider-markLabel': { color: 'text.secondary', fontSize: '0.75rem' },
                }}
              />
            </Grid>
            <Grid item>
              <Typography variant="body2" fontWeight={600} color={modernTheme.colors.primary}>
                {advancePercentage}%
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <TextField
          label="Số tiền ứng"
          type="number"
          fullWidth
          value={advanceAmount}
          onChange={onAmountChange}
          InputProps={{
            startAdornment: <InputAdornment position="start">₫</InputAdornment>,
          }}
          sx={{
            '& .MuiOutlinedInput-root': { borderRadius: 2 }
          }}
        />

        <Box sx={{ mt: 2, p: 1.5, bgcolor: '#fffbeb', borderRadius: 2, border: '1px solid #fde68a' }}>
          <Typography variant="caption" color="#92400e" fontWeight={600}>
            Lưu ý: Bạn chỉ được ứng tiền 1 lần trong tháng và không quá 50% thu nhập kỳ này.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 2 }}>
        <Button onClick={onClose} variant="outlined" sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}>
          Hủy
        </Button>
        <Button
          onClick={onSubmit}
          variant="contained"
          disabled={loading || advanceAmount <= 0}
          sx={{
            background: modernTheme.gradients.primary,
            borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 3,
            '&:hover': { background: modernTheme.gradients.primary, boxShadow: modernTheme.shadows.md },
          }}
        >
          {loading ? 'Đang gửi...' : 'Gửi yêu cầu'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AdvancePaymentDialog;
